<template>
  <div>
    <!-- Hero Section -->
    <section class="bg-gradient-to-b from-blue-600 to-blue-800 text-white py-20 relative overflow-hidden">
      <!-- Background Pattern -->
      <div class="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" stroke-width="1"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div class="container mx-auto px-4 text-center relative z-10">
        <div class="inline-block bg-white bg-opacity-10 backdrop-filter backdrop-blur-sm rounded-full px-4 py-1 mb-6 border border-white border-opacity-20">
          <span class="text-blue-100 font-semibold tracking-wide">专业云手机租赁系统</span>
        </div>
        
        <h1 class="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
          随心所欲，掌控云端。<br class="hidden md:block" />
          无论身处何处，即刻开启上云体验！
        </h1>
        
        <p class="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
          支持 Web/H5 PC App 三端控制，为您提供稳定、高效的云手机服务
        </p>
        
        <div class="flex flex-wrap justify-center gap-4 mb-12">
          <a href="#" @click.prevent="openModal" class="bg-white text-blue-600 hover:bg-blue-50 px-8 py-3 rounded-md font-bold text-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">查看演示</a>
          <router-link to="/pricing" class="bg-transparent border-2 border-white text-white hover:bg-white hover:text-blue-600 px-8 py-3 rounded-md font-bold text-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">立即订购</router-link>
        </div>
        
        <p class="mb-8 text-sm opacity-80">采用 VUE 3 + Golang 技术栈打造，性能卓越</p>
        
        <div class="flex justify-center space-x-4 md:space-x-6 mb-12">
          <div class="w-12 h-12 bg-white bg-opacity-20 backdrop-filter backdrop-blur-sm rounded-lg flex items-center justify-center border border-white border-opacity-30 shadow-inner">
            <span class="text-white font-bold text-xl">Y</span>
          </div>
          <div class="w-12 h-12 bg-white bg-opacity-20 backdrop-filter backdrop-blur-sm rounded-lg flex items-center justify-center border border-white border-opacity-30 shadow-inner">
            <span class="text-white font-bold text-xl">I</span>
          </div>
          <div class="w-12 h-12 bg-white bg-opacity-20 backdrop-filter backdrop-blur-sm rounded-lg flex items-center justify-center border border-white border-opacity-30 shadow-inner">
            <span class="text-white font-bold text-xl">S</span>
          </div>
          <div class="w-12 h-12 bg-white bg-opacity-20 backdrop-filter backdrop-blur-sm rounded-lg flex items-center justify-center border border-white border-opacity-30 shadow-inner">
            <span class="text-white font-bold text-xl">U</span>
          </div>
          <div class="w-12 h-12 bg-white bg-opacity-20 backdrop-filter backdrop-blur-sm rounded-lg flex items-center justify-center border border-white border-opacity-30 shadow-inner">
            <span class="text-white font-bold text-xl">R</span>
          </div>
        </div>
        
        <!-- Hero Image -->
        <div class="mt-8 relative max-w-5xl mx-auto">
          <div class="bg-gray-800 rounded-xl overflow-hidden shadow-2xl border-4 border-gray-700">
            <img src="../assets/images/home.png" alt="Yisur云手机界面" class="w-full h-auto" />
          </div>
          <!-- Decorative Dots -->
          <div class="absolute -bottom-6 -right-6 -z-10">
            <div class="grid grid-cols-5 gap-2">
              <div v-for="n in 25" :key="n" class="w-2 h-2 bg-blue-300 rounded-full"></div>
            </div>
          </div>
          <div class="absolute -top-6 -left-6 -z-10">
            <div class="grid grid-cols-5 gap-2">
              <div v-for="n in 25" :key="n" class="w-2 h-2 bg-blue-300 rounded-full"></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Features Section -->
    <section class="py-20 bg-gray-50">
      <div class="container mx-auto px-4">
        <div class="text-center mb-16">
          <span class="text-blue-600 font-semibold tracking-wider uppercase text-sm">核心优势</span>
          <h2 class="text-3xl md:text-4xl font-bold mb-4 mt-2 text-gray-900">为什么选择 Yisur</h2>
          <p class="text-gray-600 max-w-2xl mx-auto">Yisur云手机系统解决方案是一款基于Antd + Vue3，Golang开发的云手机综合管理系统解决方案。</p>
        </div>
        
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
          <!-- Feature 1 -->
          <div class="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-b-4 border-blue-600">
            <div class="w-14 h-14 bg-blue-50 rounded-lg flex items-center justify-center mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 class="text-2xl font-bold mb-3 text-gray-900">批量操作</h3>
            <p class="text-gray-600 leading-relaxed">
              可同时在线上百个安卓设备，画面不卡顿，操作流畅。支持批量传输文件、应用安装，清除数据等常用功能，让管理更高效。
            </p>
          </div>
          
          <!-- Feature 2 -->
          <div class="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-b-4 border-blue-600">
            <div class="w-14 h-14 bg-blue-50 rounded-lg flex items-center justify-center mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
              </svg>
            </div>
            <h3 class="text-2xl font-bold mb-3 text-gray-900">设备显示</h3>
            <p class="text-gray-600 leading-relaxed">
              自定义调节大小屏幕尺寸，支持调整小屏幕的清晰度和画质帧数，确保每个小屏幕的清晰度都符合需求，监控更直观。
            </p>
          </div>
          
          <!-- Feature 3 -->
          <div class="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-b-4 border-blue-600">
            <div class="w-14 h-14 bg-blue-50 rounded-lg flex items-center justify-center mb-6">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <h3 class="text-2xl font-bold mb-3 text-gray-900">键鼠同步</h3>
            <p class="text-gray-600 leading-relaxed">
              键鼠同步功能可以在多个设备上同步输入文字信息，减少重复输入的工作量，提高工作效率，操作更便捷。
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Application Scenarios -->
    <section class="py-20">
      <div class="container mx-auto px-4">
        <div class="text-center mb-16">
          <span class="text-blue-600 font-semibold tracking-wider uppercase text-sm">无限可能</span>
          <h2 class="text-3xl md:text-4xl font-bold mb-4 mt-2 text-gray-900">全场景解决方案</h2>
          <p class="text-gray-600 max-w-2xl mx-auto">Yisur云手机系统适用于多种场景，满足不同行业的需求</p>
        </div>
        
        <div class="grid grid-cols-2 md:grid-cols-4 gap-6">
          <div class="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 group border border-gray-100 flex flex-col items-center justify-center text-center h-full">
            <div class="w-14 h-14 bg-blue-50 rounded-full flex items-center justify-center mb-4 group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-blue-600 group-hover:text-white transition-colors duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
              </svg>
            </div>
            <h3 class="font-bold text-gray-800">Facebook引流</h3>
          </div>
          
          <div class="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 group border border-gray-100 flex flex-col items-center justify-center text-center h-full">
            <div class="w-14 h-14 bg-blue-50 rounded-full flex items-center justify-center mb-4 group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-blue-600 group-hover:text-white transition-colors duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h3 class="font-bold text-gray-800">跨境电商</h3>
          </div>
          
          <div class="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 group border border-gray-100 flex flex-col items-center justify-center text-center h-full">
            <div class="w-14 h-14 bg-blue-50 rounded-full flex items-center justify-center mb-4 group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-blue-600 group-hover:text-white transition-colors duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
              </svg>
            </div>
            <h3 class="font-bold text-gray-800">网店运营</h3>
          </div>
          
          <div class="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 group border border-gray-100 flex flex-col items-center justify-center text-center h-full">
            <div class="w-14 h-14 bg-blue-50 rounded-full flex items-center justify-center mb-4 group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-blue-600 group-hover:text-white transition-colors duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
              </svg>
            </div>
            <h3 class="font-bold text-gray-800">游戏工作室</h3>
          </div>
          
          <div class="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 group border border-gray-100 flex flex-col items-center justify-center text-center h-full">
            <div class="w-14 h-14 bg-blue-50 rounded-full flex items-center justify-center mb-4 group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-blue-600 group-hover:text-white transition-colors duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 class="font-bold text-gray-800">直播间控场</h3>
          </div>
          
          <div class="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 group border border-gray-100 flex flex-col items-center justify-center text-center h-full">
            <div class="w-14 h-14 bg-blue-50 rounded-full flex items-center justify-center mb-4 group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-blue-600 group-hover:text-white transition-colors duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
            </div>
            <h3 class="font-bold text-gray-800">AI手机训练</h3>
          </div>
          
          <div class="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 group border border-gray-100 flex flex-col items-center justify-center text-center h-full">
            <div class="w-14 h-14 bg-blue-50 rounded-full flex items-center justify-center mb-4 group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-blue-600 group-hover:text-white transition-colors duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h3 class="font-bold text-gray-800">私域运营管理</h3>
          </div>
          
          <div class="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 group border border-gray-100 flex flex-col items-center justify-center text-center h-full">
            <div class="w-14 h-14 bg-blue-50 rounded-full flex items-center justify-center mb-4 group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-blue-600 group-hover:text-white transition-colors duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
              </svg>
            </div>
            <h3 class="font-bold text-gray-800">APP仿真测试</h3>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="py-20 bg-blue-600 relative overflow-hidden">
      <!-- Decorative Circles -->
      <div class="absolute top-0 left-0 w-64 h-64 bg-white opacity-5 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
      <div class="absolute bottom-0 right-0 w-96 h-96 bg-white opacity-5 rounded-full translate-x-1/3 translate-y-1/3"></div>

      <div class="container mx-auto px-4 text-center relative z-10">
        <h2 class="text-3xl md:text-4xl font-bold mb-6 text-white">准备好体验Yisur云手机了吗？</h2>
        <p class="text-xl text-blue-100 mb-10 max-w-3xl mx-auto">立即开启云端之旅，享受高效的设备管理体验</p>
        <div class="flex flex-wrap justify-center gap-6">
          <a href="#" @click.prevent="openModal" class="bg-white text-blue-600 hover:bg-blue-50 px-8 py-4 rounded-lg font-bold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 text-lg">免费试用</a>
          <router-link to="/contact" class="bg-transparent border-2 border-white text-white hover:bg-white hover:text-blue-600 px-8 py-4 rounded-lg font-bold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 text-lg">联系我们</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { useVersionModal } from '@/composables/useVersionModal';

export default {
  name: 'Home',
  setup() {
    const { openModal } = useVersionModal();
    return { openModal };
  }
}
</script> 